import { Mapper } from "../../../../base/utils/mapper";
import { TypeDiagnosticModel } from "../../../../domain/models/consult/type-diagnostic.model";
import { TypeDiagnosticEntity } from "../entities/type-diagnostic.entity";


export class TypeDiagnosticImplementationRepositoryMapper extends Mapper<TypeDiagnosticEntity, TypeDiagnosticModel> {
    mapFrom(param: TypeDiagnosticEntity): TypeDiagnosticModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeDiagnosticModel): TypeDiagnosticEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}